import ConnectedDebtor from "./ConnectedDebtor";

export default ConnectedDebtor
